<template>
  <!-- 右侧tab内容区骨架屏：达人基础数据(getKsProfile)返回前占位，避免内容区空白 -->
  <div class="tab-skeleton">
    <div class="sk-card">
      <div class="sk-line" style="width: 80px;"></div>
      <div class="sk-row">
        <div class="sk-block" v-for="i in 3" :key="'b'+i"></div>
      </div>
      <div class="sk-line" style="width: 80px; margin-top: 24px;"></div>
      <div class="sk-row">
        <div class="sk-block" v-for="i in 3" :key="'c'+i"></div>
      </div>
      <div class="sk-line" style="width: 100px; margin-top: 24px;"></div>
      <div class="sk-tags">
        <span v-for="i in 6" :key="'t'+i"></span>
      </div>
    </div>
    <div class="sk-card">
      <div class="sk-line" style="width: 80px;"></div>
      <div class="sk-split">
        <div class="sk-chart"></div>
        <div class="sk-lines">
          <div class="sk-line" v-for="i in 5" :key="'l'+i" :style="{width: (90 - i * 8) + '%'}"></div>
        </div>
      </div>
    </div>
    <div class="sk-card">
      <div class="sk-line" style="width: 120px;"></div>
      <div class="sk-chart sk-chart-wide"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabSkeleton",
};
</script>

<style scoped lang="less">
.tab-skeleton{
    .sk-card{
        margin-bottom: 15px;
        padding: 20px 24px 24px;
        background: #fff;
        border-radius: 6px;
        box-sizing: border-box;
    }
    .sk-line{
        height: 16px;
        margin-bottom: 16px;
        border-radius: 4px;
    }
    .sk-row{
        display: flex;
        gap: 40px;
    }
    .sk-block{
        flex: 1;
        height: 64px;
        border-radius: 4px;
    }
    .sk-tags{
        span{
            display: inline-block;
            width: 72px;
            height: 24px;
            margin: 0 10px 10px 0;
            border-radius: 2px;
        }
    }
    .sk-split{
        display: flex;
        gap: 40px;
        align-items: center;
    }
    .sk-chart{
        width: 320px;
        height: 220px;
        border-radius: 4px;
        &.sk-chart-wide{
            width: 100%;
            height: 260px;
        }
    }
    .sk-lines{
        flex: 1;
        .sk-line{
            height: 20px;
            margin-bottom: 20px;
        }
    }
    // 微光扫过动画
    .sk-line, .sk-block, .sk-tags span, .sk-chart{
        background: linear-gradient(90deg, #f2f3f5 25%, #e6e8eb 37%, #f2f3f5 63%);
        background-size: 400% 100%;
        animation: sk-shimmer 1.4s ease infinite;
    }
    @keyframes sk-shimmer{
        0% { background-position: 100% 50%; }
        100% { background-position: 0 50%; }
    }
}
</style>
